<template>
  <div class="home">
    <!-- 加载中 -->
    <div class="cover-wrap" v-show="loading_switch"></div>
    <!-- <div class="loading-box" v-show="loading_switch">
      <van-loading vertical class="loading" color="#fff">{{ loading_tip }}</van-loading>
    </div> -->
    <div class="loading-box" v-show="loading_switch">
      <div class="content">
        <div class="icon">
          <img src="https://pgcloud.aitici.com/common/20241230/afefdac6b0d4401c9547c13b8d3ac39d.webp" mode="aspectFill">
        </div>
        <div class="title">{{ loading_title }}</div>
        <div class="description">{{ loading_tip }}</div>
      </div>
    </div>

    <!-- 头部 -->
    <div class="head-wrap">
      <div class="head-title">
        <img src="https://pgcloud.aitici.com/common/20250807/27e19698de1c45679d610948e5f7c752.png">
      </div>
      <div class="icon">
        <img src="https://pgcloud.aitici.com/common/20250807/4218d880c04e49e1b8e5333de952d987.png">
      </div>
    </div>

    <div class="q-box">
      <Collapse />
    </div>

    <!-- <div class="head-wrap">
      <div class="icon">
        <img src="https://pgcloud.aitici.com/common/20241226/5d3d611e0f2e4aa5801876b1c5552eb7.png" mode="aspectFill">
      </div>
      <div class="function-box">
        <div class="input-mobile">
          <input v-model="phone" @focus="mobileIsHas=false;mobileIsFocus=true" @blur="mobileIsFocus=false" type="tel" placeholder="输入手机号为您一键退款" placeholder-style="color: #999999;" :class="{ 'input-mobile__no':mobileIsHas,'input-mobile__focus': mobileIsFocus }" />
        </div>
        <div class="btn-query" @click="handleCustomerAutoRefund()">极速退款</div>
        <div class="tips">
          *客服热线：400-765-8113
        </div>
      </div>
    </div> -->

    <!-- 主要内容 -->
    <div class="body-wrap">
      <div class="function-box">
        <div class="fun-title">
          <img src="https://pgcloud.aitici.com/common/20250807/29502aa2134446e5b6fa0b4cb44b6805.png">
        </div>
        <div :class="{'input-mobile':true, 'input-mobile__no':mobileIsHas,'input-mobile__focus': mobileIsFocus }">
          <input v-model="phone" @focus="mobileIsHas=false;mobileIsFocus=true" @blur="mobileIsFocus=false" type="tel" placeholder="输入手机号为您一键退款" placeholder-style="color: #999999;" />
        </div>
        <div class="btn-query" @click="handleCustomerAutoRefund()">
          <img src="https://pgcloud.aitici.com/common/20250113/b58f75a7cb524c07ab7b007c80329b33.webp">
        </div>
        <div class="tips">
          退款成功后将取消自动续费，后续不会再扣费
        </div>
      </div>
    </div>

    <div class="foot-wrap">
			<div class="btn-box">
				<div class="item" @click="handleGoComplaint()">
					<div class="icon">
						<img src="https://pgcloud.aitici.com/common/20250807/ed27b6c69c254d4786ab3237b5772b55.png">
					</div>
					<div class="text">
						举报投诉
					</div>
				</div>
				<div class="item" @click="handleTelephoneRefund('5')">
					<div class="icon">
						<img src="https://pgcloud.aitici.com/common/20250807/a10868de0b634054ab095f98a2a9fd6d.png">
					</div>
					<div class="text">
						人工客服
					</div>
				</div>
			</div>
		</div>

    <!-- 在线客服 -->
    <div class="fixation-btn" @click="handleGoChat()"></div>

    <van-popup v-model="showErrorPopupFlag" @click-overlay="showErrorPopupFlag=false" @click="showErrorPopupFlag=false" :close-on-click-overlay="false" style="background-color: transparent;">
      <div class="error-popup-wrap">
        <div class="btn-cancel">
          <img src="https://pgcloud.aitici.com/common/20241219/17bc09368d9a489f9321e5ea9661a0e9.png" mode="aspectFill">
        </div>
        <div class="main-icon">
          <img src="https://pgcloud.aitici.com/common/20241219/4bad7d0473f14323a2f81b8148291cd7.png" mode="aspectFill">
        </div>
        <div class="main-content" @click.stop="">
          <div class="title">
            未查到可在线退款的订单
          </div>
          <div class="description">
            当前未查到可以在线退款的订单，如有疑问可拨打400官方热线，我们竭诚24小时为您解决问题。
          </div>
          <div class="btn-mobile" @click.stop="handleTelephoneRefund('1001')">
            <div class="btn-icon"><img src="https://pgcloud.aitici.com/common/20241219/648c9f64e0134bbd882071eda1a3f384.png" mode="aspectFill"></div>
            <div class="btn-text">联系 400 官方客服</div>
          </div>
          <div class="tips">
            客服热线:400-765-8113
          </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import {
  ApiCustomerOrderGet,
  ApiCustomerRefundApplySubmit,
  ApiCustomerAllOrderGet,
  ApiCustomerAllRefundApplySubmit,
  ApiCustomerGetRefundableOrders,
  ApiCustomerAutoRefund,
} from "@/api/customer.js";
import Collapse from "@/components/Collapse/Collapse.vue";
export default {
  name: "Homediv",
  components: {
    Collapse,
  },
  data() {
    return {
      loading_switch: false,
      loading_title: "",
      loading_tip: "",
      timer: null,
      timer1: null,

      phone: "",
      mobileIsFocus: false,
      mobileIsHas: false,
      showErrorPopupFlag: false,

      radio: "1",
      orderList: [],
      report_list: {},

      order: {},
      refundOrderList: [],
    };
  },

  created() {},

  destroyed() {
    clearTimeout(this.timer);
    clearTimeout(this.timer1);
  },

  methods: {
    // 查询订单并退款（包含php和java双平台）
    handleCustomerAutoRefund() {
      let place = "9";
      this.eventTracking(place);
      this.handleRefundEventReport();

      if (!this.phone) {
        window.scrollTo(0, 0);
        this.mobileIsHas = true;
        this.$toast("请填写手机号");
        return;
      }

      if (this.phone.length != 11) {
        window.scrollTo(0, 0);
        this.mobileIsHas = true;
        this.$toast("联系方式不合法");
        return;
      }

      this.loading_title = "极速退款中";
      this.loading_tip = "正在查询订单，请稍候...";
      this.loading_switch = true;
      localStorage.setItem("phone", this.phone);
      this.timer1 = setTimeout(() => {
        this.loading_tip = "全力查询中，预计需要几秒钟，请稍等...";
      }, 2000);

      ApiCustomerAutoRefund({
        contact: this.phone,
        originMerchName: this.$MERCHANTNAME,
        originType: 1,
        onlyOne: 1,
        from: "zfb_h5",
        isAutoRefund: 1,
      })
        .then((res) => {
          this.loading_switch = false;

          if (res.code == 206) {
            localStorage.setItem("statue", "err");
            this.$router.push({ name: "online" });
            return;
          }

          if (res.code !== 0) {
            this.showErrorPopupFlag = true;
            return;
          }

          const resultData = res.data;

          // php处理逻辑
          if (resultData.phpOrders && resultData.phpOrders.length) {
            const phpOrder = resultData.phpOrders[0];
            this.reportAutoRefund();
            let reportList = {
              success: [
                {
                  transaction_id: phpOrder.transactionId,
                  paytime: phpOrder.payTime,
                  price: phpOrder.price,
                },
              ],
              fail: [],
            };
            localStorage.setItem("statue", "succ");
            localStorage.setItem("report_list", JSON.stringify(reportList));
            this.$router.push({ name: "online" });
            return;
          }

          // java处理逻辑
          if (resultData.javaOrders && resultData.javaOrders.length) {
            let reportList = {
              success: [],
              fail: [],
            };

            resultData.javaOrders.forEach((item, index) => {
              if (item.refunded) {
                reportList.success.push({
                  transaction_id: `${item.applicationName}(${item.goodsPackageName})`,
                  paytime: item.payTime,
                  price: item.refundableAmount,
                });
              } else {
                reportList.fail.push({
                  transaction_id: `${item.applicationName}(${item.goodsPackageName})`,
                  paytime: item.payTime,
                  price: item.refundableAmount,
                });
              }
            });
            // 存储结果并跳转
            localStorage.setItem("statue", "succ");
            localStorage.setItem("report_list", JSON.stringify(reportList));
            this.$router.push({ name: "online" });
            return;
          }

          // javaOrders和phpOrders都为空
          localStorage.setItem("statue", "err");
          this.$router.push({ name: "online" });
        })
        .catch(() => {
          this.loading_switch = false;
          this.showErrorPopupFlag = true;
        });
    },
    // ==========================================
    // 查询Java订单
    handleGetJavaOrder() {
      ApiCustomerOrderGet({ mobile: this.phone })
        .then((res) => {
          this.loading_switch = false;
          if (res.code !== 0) {
            this.showErrorPopupFlag = true;
            return;
          }
          if (res.data && res.data.length) {
            this.refundOrderList = [];
            res.data.forEach((item, index) => {
              this.refundOrderList.push({
                id: item.id,
                refundableAmount: item.refundableAmount,
                tenantCode: item.tenantCode,
                productId: item.productId,
                applicationId: item.applicationId,
                name: `${item.applicationName}(${item.goodsPackageName})`,
                time: item.payTime,
                price: item.refundableAmount,
              });
            });
            this.handleJavaBatchOrderRefund();
          } else {
            this.showErrorPopupFlag = true;
          }
        })
        .catch(() => {
          this.loading_switch = false;
          this.showErrorPopupFlag = true;
        });
    },
    // 批量退款
    async handleJavaBatchOrderRefund() {
      this.loading_tip = "系统处理中，请勿离开本页面";
      this.loading_switch = true;

      // 创建所有退款请求
      const requests = this.refundOrderList.map((order) =>
        this.handleJavaOrderRefundByPromise(order)
      );

      // 等待所有请求完成
      const results = await Promise.all(requests);

      // 存储结果并跳转
      this.report_list = {
        success: [],
        fail: [],
      };
      results.forEach((item, index) => {
        if (item.success) {
          this.report_list.success.push({
            transaction_id: item.name,
            paytime: item.time,
            price: item.price,
          });
        } else {
          this.report_list.fail.push({
            transaction_id: item.name,
            paytime: item.time,
            price: item.price,
          });
        }
      });

      localStorage.setItem("statue", "succ");
      localStorage.setItem("report_list", JSON.stringify(this.report_list));
      setTimeout(() => {
        this.loading_switch = false;
        this.$router.push({ name: "online" });
      }, 100);
    },
    // 单条退款（Promise 风格调用）
    handleJavaOrderRefundByPromise(orderInfo) {
      const data = {
        orderId: orderInfo.id,
        amount: orderInfo.refundableAmount,
        contact: this.mobile,

        tenantCode: orderInfo.tenantCode,
        productId: orderInfo.productId,
        applicationId: orderInfo.applicationId,
      };

      return ApiCustomerRefundApplySubmit(data)
        .then((res) => {
          if (res.code !== 0) {
            return {
              name: orderInfo.name,
              time: orderInfo.time,
              price: orderInfo.price,
              success: false,
            };
          }

          if (res.data.status == 2) {
            return {
              name: orderInfo.name,
              time: orderInfo.time,
              price: orderInfo.price,
              success: true,
            };
          } else {
            return {
              name: orderInfo.name,
              time: orderInfo.time,
              price: orderInfo.price,
              success: false,
            };
          }
        })
        .catch(() => {
          return {
            name: orderInfo.name,
            time: orderInfo.time,
            price: orderInfo.price,
            success: false,
          };
        });
    },
    // 一键退款
    handleJavaOrderRefund() {
      this.loading_tip = "系统处理中，请勿离开本页面";
      this.loading_switch = true;
      const data = {
        orderId: this.order.id,
        amount: this.order.refundableAmount,
        contact: this.phone,

        tenantCode: this.order.tenantCode,
        productId: this.order.productId,
        applicationId: this.order.applicationId,
      };
      ApiCustomerRefundApplySubmit(data)
        .then((res) => {
          this.loading_switch = false;

          if (res.code == 206) {
            localStorage.setItem("statue", "err");
            setTimeout(() => {
              this.$router.push({ name: "online" });
            }, 100);
            return;
          }

          if (res.code !== 0) {
            return this.$toast(res.msg);
          }
          if (res.data.status == 1) {
            localStorage.setItem("statue", "err");
            setTimeout(() => {
              this.loading_switch = false;
              this.$router.push({ name: "online" });
            }, 100);
          } else if (res.data.status == 2) {
            this.report_list = {
              success: [
                {
                  transaction_id: this.order.name,
                  paytime: this.order.time,
                  price: this.order.price,
                },
              ],
              fail: [],
            };
            localStorage.setItem("statue", "succ");
            localStorage.setItem(
              "report_list",
              JSON.stringify(this.report_list)
            );
            setTimeout(() => {
              this.loading_switch = false;
              this.$router.push({ name: "online" });
            }, 100);
          }
        })
        .catch(() => {
          this.loading_switch = false;
          this.showErrorPopupFlag = true;
        });
    },
    // ============================ 批量退款（支持普通付费订单） ============================
    // 1. 查询订单
    handleGetJavaAllOrder() {
      ApiCustomerGetRefundableOrders({
        contact: this.phone,
        originMerchName: this.$MERCHANTNAME,
        originType: "支付宝H5",
      })
        .then((res) => {
          this.loading_switch = false;
          if (res.code !== 0) {
            this.showErrorPopupFlag = true;
            return;
          }
          if (res.data && res.data.length) {
            this.refundOrderList = [];
            res.data.forEach((item, index) => {
              this.refundOrderList.push({
                id: item.id,
                orderNo: item.orderNo,
                tradeNo: item.tradeNo,
                amount: item.refundableAmount,

                tenantCode: item.tenantCode,
                productId: item.productId,
                applicationId: item.applicationId,

                name: `${item.applicationName}(${item.goodsPackageName})`,
                time: item.payTime,
                price: item.refundableAmount,
                success: false,
              });
            });
            this.handleReportBeforeRefundingEventReport();
            this.handleJavaAllOrderRefund();
          } else {
            this.showErrorPopupFlag = true;
          }
        })
        .catch(() => {
          this.loading_switch = false;
          this.showErrorPopupFlag = true;
        });
    },
    // 2. 退款
    handleJavaAllOrderRefund() {
      this.loading_tip = "系统处理中，请勿离开本页面";
      this.loading_switch = true;
      let data = [];
      this.refundOrderList.forEach((item, index) => {
        data.push({
          orderId: item.id,
          orderNo: item.orderNo,
          tradeNo: item.tradeNo,
          amount: item.amount,
          tenantCode: item.tenantCode,
          productId: item.productId,
          applicationId: item.applicationId,
          contact: this.phone,
          originMerchName: this.$MERCHANTNAME,
          originType: "支付宝H5",
        });
      });
      ApiCustomerAllRefundApplySubmit(data)
        .then((res) => {
          this.loading_switch = false;

          if (res.code !== 0) {
            return (this.showErrorPopupFlag = true);
          }

          let batchResult = res.data?.batchResult ? res.data.batchResult : {};
          this.refundOrderList.forEach((item, index) => {
            item.success = batchResult[item.orderNo] ? true : false;
          });

          // 存储结果并跳转
          this.report_list = {
            success: [],
            fail: [],
          };
          this.refundOrderList.forEach((item, index) => {
            if (item.success) {
              this.report_list.success.push({
                transaction_id: item.name,
                paytime: item.time,
                price: item.price,
              });
            } else {
              this.report_list.fail.push({
                transaction_id: item.name,
                paytime: item.time,
                price: item.price,
              });
            }
          });

          localStorage.setItem("statue", "succ");
          localStorage.setItem("report_list", JSON.stringify(this.report_list));
          setTimeout(() => {
            this.loading_switch = false;
            this.$router.push({ name: "online" });
          }, 100);
        })
        .catch(() => {
          this.loading_switch = false;
          this.showErrorPopupFlag = true;
        });
    },
    // ============================

    //查询订单并退款
    async handleSubmitForm() {
      let place = "9";
      this.eventTracking(place);
      this.handleRefundEventReport();

      if (!this.phone) {
        window.scrollTo(0, 0);
        this.mobileIsHas = true;
        this.$toast("请填写手机号");
        return;
      }

      if (this.phone.length != 11) {
        window.scrollTo(0, 0);
        this.mobileIsHas = true;
        this.$toast("联系方式不合法");
        return;
      }
      this.loading_title = "极速退款中";
      this.loading_tip = "正在查询订单，请稍候...";
      this.loading_switch = true;
      localStorage.setItem("phone", this.phone);
      this.timer1 = setTimeout(() => {
        this.loading_tip = "全力查询中，预计需要几秒钟，请稍等...";
      }, 2000);

      let only_one = "1";
      if (this.radio == "2") {
        only_one = "0";
      }
      let res = await this.$axios
        .post(
          "https://middlegrounpcomplaint.juzan.info/api/order/searchByPhoneWithRefundReport",
          {
            phone: this.phone,
            only_one,
          }
        )
        .catch((err) => {
          // this.loading_switch = false;
          // this.showErrorPopupFlag = true;
          this.handleGetJavaAllOrder();
        });
      let findRes = res.data;
      // console.log('查询结果==>', findRes);
      if (findRes.code == 200) {
        //200 - 成功获取订单
        if (findRes.data.is_reprot == 0) {
          this.orderList = [];
          findRes.data.refund_list.forEach((item, index) => {
            item.isChecked = true;
            item.pay_time = this.getFormattedDate(item.pay_time);
            if (item.spec_dx >= 36000) {
              item.spec_dx = "终身卡";
            } else {
              item.spec_dx = item.spec_dx + "天";
            }
            this.orderList.push(item);
          });
          this.handleReportBeforeRefundingEventReport();
          this.handleRefund();
        } else if (findRes.data.is_reprot == 1) {
          this.reportAutoRefund();
          let successArr = [];
          let failArr = [];
          findRes.data.report_list.success.forEach((item, index) => {
            item.paytime = this.getFormattedDate(item.paytime);
            successArr.push(item);
          });

          findRes.data.report_list.fail.forEach((item, index) => {
            item.paytime = this.getFormattedDate(item.paytime);
            failArr.push(item);
          });

          this.report_list = {
            success: successArr,
            fail: failArr,
          };
          localStorage.setItem("statue", "succ");
          localStorage.setItem("report_list", JSON.stringify(this.report_list));
          setTimeout(() => {
            this.loading_switch = false;
            this.$router.push({ name: "online" });
          }, 100);
        }
      } else if (findRes.code == 204) {
        //204 - 未获取到订单数据
        // this.loading_switch = false;
        // this.showErrorPopupFlag = true;
        this.handleGetJavaAllOrder();
      } else {
        //400 - 参数异常
        // this.loading_switch = false;
        // this.showErrorPopupFlag = true;
        this.handleGetJavaAllOrder();
      }
    },

    //一键退款并关闭自动续费
    async handleRefund() {
      let place = "11";
      this.eventTracking(place);

      this.loading_tip = "系统处理中，请勿离开本页面";
      this.loading_switch = true;

      let actOrder = [];
      this.orderList.forEach((item, index) => {
        if (item.isChecked) {
          let obj = {};
          obj.platform = item.platform_id;
          obj.order_no = item.order_no;
          actOrder.push(obj);
        }
      });
      // console.log("选中退款订单",actOrder);

      //执行退款操作
      let res = await this.$axios
        .post(
          "https://middlegrounpcomplaint.juzan.info/api/order/submitRefundWithAutoRefund",
          {
            phone: this.phone,
            refund_list: actOrder,
            is_auto_refund: 1,
          }
        )
        .catch((err) => {
          this.loading_switch = false;
          this.showErrorPopupFlag = true;
        });
      let subRes = res.data;
      // console.log('查询结果==>', subRes);

      if (subRes.code == 200) {
        // this.loading_switch = false;
        this.reportAutoRefund();
        let successArr = [];
        let failArr = [];
        subRes.data.success.forEach((item, index) => {
          item.paytime = this.getFormattedDate(item.paytime);
          successArr.push(item);
        });

        subRes.data.fail.forEach((item, index) => {
          item.paytime = this.getFormattedDate(item.paytime);
          failArr.push(item);
        });

        this.report_list = {
          success: successArr,
          fail: failArr,
        };
        localStorage.setItem("statue", "succ");
        localStorage.setItem("report_list", JSON.stringify(this.report_list));
        setTimeout(() => {
          this.loading_switch = false;
          this.$router.push({ name: "online" });
        }, 100);
      } else if (subRes.code == 206) {
        this.reportAutoRefund();
        localStorage.setItem("statue", "err");
        setTimeout(() => {
          this.loading_switch = false;
          this.$router.push({ name: "online" });
        }, 100);
      } else {
        this.reportAutoRefund();
        this.loading_switch = false;
        this.showErrorPopupFlag = true;
        // this.$toast('该订单在线退款失败，请选择电话极速退款');
      }
    },

    // 格式化时间戳
    getFormattedDate(time) {
      const timestamp = time * 1000; // 待转换的时间戳
      const date = new Date(timestamp); // 根据时间戳创建Date对象
      const year = date.getFullYear(); // 获取年份
      const month = date.getMonth() + 1; // 获取月份，需要加1
      const day = date.getDate(); // 获取日期
      let hour = date.getHours(); // 获取小时
      hour = hour < 10 ? "0" + hour : hour;
      let minute = date.getMinutes(); // 获取分钟
      minute = minute < 10 ? "0" + minute : minute;
      let second = date.getSeconds(); // 获取秒数
      second = second < 10 ? "0" + second : second;
      const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`; // 拼接成格式化后的日期字符串

      return formattedDate;
    },

    //上报
    async reportAutoRefund() {
      let res = await this.$axios.get(
        "https://middlegrounpcomplaint.juzan.info/api/order/reportAutoRefund",
        {
          headers: {
            Authorization: this.phone,
          },
        }
      );
      // console.log('上报状态', res);
    },

    //提交投诉
    handleGoComplaint() {
      let place = "3";
      this.eventTracking(place);
      this.handleComplaintEventReport();
      this.$router.push("./oldcomplaint");
    },

    //在线自助退款
    handleRefundOnline() {
      let place = "1";
      this.eventTracking(place);
      this.handleRefundEventReport();
      sessionStorage.removeItem("statue");
      sessionStorage.removeItem("btnStatue");
      sessionStorage.removeItem("orderList");
      sessionStorage.removeItem("report_list");

      this.$router.push({ name: "online" });
    },
    // 电话退款
    handleTelephoneRefund(place) {
      this.eventTracking(place);
      window.location.href = `tel:4007658113`;
    },

    //在线客服
    async handleGoChat() {
      let place = "6";
      this.eventTracking(place);
      this.handleOnlineEventReport();
      this.loading_title = "极速加载中";
      this.loading_tip = "预计需要几秒钟，请稍等...";
      this.loading_switch = true;
      let info = { uid: "", data: [], gid: "482707004" };

      info.data = [{ key: "real_name", value: "支付宝" }];

      await this.fishkefu.Config(info);
      let qysdk = await this.fishkefu.openSdk();
      if (qysdk == "sdk尚未加载成功，请稍后再试") {
        this.timer = null;
        this.timer = setTimeout(async () => {
          await this.fishkefu.Config(info);
          let qysdk1 = await this.fishkefu.openSdk();
          this.loading_switch = false;
          if (qysdk1 == "sdk尚未加载成功，请稍后再试") {
            alert("sdk尚未加载成功，请稍后再试");
          }
        }, 3000);
      } else {
        this.loading_switch = false;
      }
    },

    //数据埋点
    async eventTracking(place) {
      let res = await this.$axios.post(
        "https://middlegrounpcomplaint.juzan.info/api/access_log/add",
        {
          place,
        }
      );
      // console.log('查看埋点数据', res);
      if (place == "2") {
        let taskId = localStorage.getItem("taskId");
        this.reportEvent(taskId, "cs_top_button_click");
      }

      if (place == "5") {
        let taskId = localStorage.getItem("taskId");
        this.reportEvent(taskId, "cs_bottom_button_click");
      }

      if (place == "1001") {
        let taskId = localStorage.getItem("taskId");
        this.reportEvent(taskId, "cs_result_page_button_click");
      }
    },

    //埋点数据上报
    async reportEvent(c_no, event) {
      let res = await this.$axios.post(
        "https://middlegrounpcomplaint.juzan.info/api/event/index",
        {
          event: event,
          attr: "1",
          c_no: c_no,
          source: 1,
          merchant: this.$MERCHANT,
        }
      );
    },
    // 事件上报--点击投诉
    handleComplaintEventReport() {
      const c_no = localStorage.getItem("taskId");
      this.$axios.post(
        "https://middlegrounpcomplaint.juzan.info/api/event/index",
        {
          event: "complaint_button_click",
          attr: "main",
          c_no: c_no,
          source: 1,
          merchant: this.$MERCHANT,
        }
      );
    },
    // 事件上报--点击在线退款
    handleRefundEventReport() {
      const c_no = localStorage.getItem("taskId");
      this.$axios.post(
        "https://middlegrounpcomplaint.juzan.info/api/event/index",
        {
          event: "refund_button_click",
          attr: "main",
          c_no: c_no,
          source: 1,
          merchant: this.$MERCHANT,
        }
      );
    },
    // 事件上报--点击在线客服悬浮球
    handleOnlineEventReport() {
      const c_no = localStorage.getItem("taskId");
      this.$axios.post(
        "https://middlegrounpcomplaint.juzan.info/api/event/index",
        {
          event: "online_cs_click",
          attr: "main",
          c_no: c_no,
          source: 1,
          merchant: this.$MERCHANT,
        }
      );
    },
    // 事件上报--退款前上报手机号
    handleReportBeforeRefundingEventReport() {
      const c_no = localStorage.getItem("taskId");
      this.$axios.post(
        "https://middlegrounpcomplaint.juzan.info/api/event/index",
        {
          event: "report_before_refunding",
          attr: "main",
          c_no: c_no,
          source: 1,
          merchant: this.$MERCHANT,
          mobile: this.phone,
        }
      );
    },
  },
};
</script>

<style lang="less">
@import url("./home.less");
</style>
